import type { ComponentProps } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

export function FieldSelect({ className, children, ...props }: ComponentProps<"select">) {
  return <div className={cn("relative", className)}>
    <select
      {...props}
      className="border-input dark:bg-input/30 h-9 w-full min-w-32 appearance-none rounded-md border bg-transparent py-1 pr-9 pl-3 text-sm shadow-xs outline-none transition-[color,box-shadow] focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50"
    >
      {children}
    </select>
    <ChevronDown aria-hidden="true" className="text-muted-foreground pointer-events-none absolute top-1/2 right-3 size-4 -translate-y-1/2" />
  </div>;
}
